var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useContext } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { ThemeContext } from 'styled-components';
import { Button, Card, Container, Typography } from '../';
import { getBPHelpers } from '../../utils/breakpoints';
export var ToDoListCard = forwardRef(function ToDoListCard(_a, ref) {
    var actionIcon = _a.actionIcon, actionText = _a.actionText, actionLink = _a.actionLink, body = _a.body, title = _a.title, done = _a.done, onActionClicked = _a.onActionClicked, className = _a.className, style = _a.style, color = _a.color, rest = __rest(_a, ["actionIcon", "actionText", "actionLink", "body", "title", "done", "onActionClicked", "className", "style", "color"]);
    var theme = useContext(ThemeContext);
    var BPHelpers = getBPHelpers(theme.breakpoints);
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    var screens = BPHelpers.useScreens();
    return (React.createElement(Card, __assign({ className: className, ref: ref, style: style, heading: React.createElement(Container, { alignItems: 'center', flex: true },
            React.createElement(Container, { flex: true, inline: true },
                React.createElement("div", { style: {
                        width: '25px',
                        height: '25px',
                        borderRadius: '50%',
                        border: "1px solid " + color,
                        background: done ? "" + color : 'transparent'
                    } })),
            React.createElement(Container, { flex: true, inline: true, left: 'small' },
                React.createElement(Typography, { weight: 'semibold', size: 'medium' }, title))), startAdornment: React.createElement(Container, { top: screens({ small: 'small' }, undefined) },
            React.createElement(Typography, { as: 'span', size: 'medium' }, body),
            actionText && (React.createElement(Container, { flex: true, top: 'small' },
                React.createElement(Button, { as: actionLink && RouterLink, to: actionLink, icon: actionIcon && actionIcon, color: color, size: 'small', stopPropagation: true, onClick: function (e) { return onActionClicked && onActionClicked(e); } }, actionText)))), open: screens({ small: false }, true), disabled: screens({ small: false }, true), padding: screens({ small: 'small' }) }, rest)));
});
ToDoListCard.defaultProps = {
    color: 'black',
    done: false
};
ToDoListCard.displayName = 'ToDoListCard';
export default ToDoListCard;
//# sourceMappingURL=ToDoListCard.js.map